import { c as _c } from "react/compiler-runtime";
import { redirect } from 'next/navigation';
import { PETA_CAMPAIGN_HANDOFF_PARAM } from '@/features/marketing/peta-campaign/core';
import { loadWatchContext, PlayerGate, WatchPlayer } from '@/features/video';
type SearchParams = Record<string, string | string[] | undefined>;
function stringifySearchParams(searchParams?: SearchParams) {
  if (!searchParams) return '';
  const usp = new URLSearchParams();
  for (const [key, value] of Object.entries(searchParams)) {
    if (value == null) continue;
    if (Array.isArray(value)) {
      for (const v of value) usp.append(key, v);
    } else {
      usp.set(key, value);
    }
  }
  const qs = usp.toString();
  return qs ? `?${qs}` : '';
}
const LEGACY_WATCH_SEGMENT_CANONICAL: Record<string, string> = {
  'sd-film': 'standard-film'
};
function canonicalizeLegacySegment(segment: string) {
  return LEGACY_WATCH_SEGMENT_CANONICAL[segment] ?? segment;
}
export async function WatchRoute(t0) {
  const $ = _c(17);
  const {
    segment,
    searchParams
  } = t0;
  const canonical = canonicalizeLegacySegment(segment);
  if (canonical !== segment) {
    redirect(`/watch/${canonical}${stringifySearchParams(searchParams)}`);
  }
  let t1;
  if ($[0] !== segment) {
    t1 = await loadWatchContext(segment);
    $[0] = segment;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const context = t1;
  const handoffValue = searchParams?.[PETA_CAMPAIGN_HANDOFF_PARAM];
  let t2;
  if ($[2] !== handoffValue) {
    t2 = Array.isArray(handoffValue) ? handoffValue.includes("1") : handoffValue === "1";
    $[2] = handoffValue;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const campaignHandoff = t2;
  if (!context.watchAccess.hasAccess) {
    const t3 = context.watchAccess.reason ?? "expired";
    let t4;
    if ($[4] !== context.watchAccess.expiresAt || $[5] !== t3) {
      t4 = <PlayerGate reason={t3} expiresAt={context.watchAccess.expiresAt} />;
      $[4] = context.watchAccess.expiresAt;
      $[5] = t3;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  const t3 = campaignHandoff && Boolean(context.campaignAttribution);
  let t4;
  if ($[7] !== context.campaignAttribution || $[8] !== context.embedUrl || $[9] !== context.freeAccessEndsAtIso || $[10] !== context.freeAccessLabel || $[11] !== context.showHdUpsell || $[12] !== context.slug || $[13] !== context.videoId || $[14] !== context.videoTitle || $[15] !== t3) {
    t4 = <WatchPlayer videoId={context.videoId} videoTitle={context.videoTitle} slug={context.slug} showHdUpsell={context.showHdUpsell} embedUrl={context.embedUrl} freeAccessLabel={context.freeAccessLabel} freeAccessEndsAtIso={context.freeAccessEndsAtIso} campaignAttribution={context.campaignAttribution} campaignHandoff={t3} />;
    $[7] = context.campaignAttribution;
    $[8] = context.embedUrl;
    $[9] = context.freeAccessEndsAtIso;
    $[10] = context.freeAccessLabel;
    $[11] = context.showHdUpsell;
    $[12] = context.slug;
    $[13] = context.videoId;
    $[14] = context.videoTitle;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}